<div class="wrapper">
  @if (icon()) {
    <div class="icon">
      <i class="fal fa-{{ icon() }}"></i>
    </div>
  }
  <div class="text">
    {{ text() | translate }}
  </div>
</div>
